import styled from "styled-components"

export const LegalText = styled.p`
  font-size: 12pt;
  color: #6a6a6a;
`
